import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EnvService } from 'src/app/services/env.service';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { listArticle } from 'src/interface/article';
import { themeData } from 'src/interface/themesetting';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-article-section',
    templateUrl: './article-section.component.html',
    styleUrls: ['./article-section.component.scss'],
})
export class ArticleSectionComponent implements OnInit {
    articleCoverImageUrl: string;
    @Input() journalid: string;
    @Input() section: string;
    @Input() queryParams: {
        length: number;
        start: number;
        search_key: string;
        search_filters: string;
        search_keywords: string;
        sort_by: string;
    };
    defaultCoverImage: string;
    articleData: listArticle[] = [];
    themeSettingsData: themeData;
    authorsFullName: string;
    subcriptionArr: Subscription[] = [];

    constructor(
        private EnvService: EnvService,
        private articleService: GetArticlesService,
        private mainBodyService: MainBodyService,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: any
    ) {}

    ngOnInit(): void {
        this.getArticlesList(this.section);
        this.articleCoverImageUrl =
            this.EnvService.articleCoverImage + this.journalid + '/';
        this.defaultCoverImage =
            this.EnvService.defaultImagePath +
            this.EnvService.default_articleCoverImage;
        if (this.journalid) {
            const journalid = this.mainBodyService
                .getAllThemeSettings(this.journalid)
                .subscribe((result) => {
                    if (result.status === 200) {
                        this.themeSettingsData = result.data;
                        if (isPlatformBrowser(this.platformId)) {
                            Object.entries(this.themeSettingsData.theme_colors).map(
                                ([key, value]) => {
                                    const element = '--' + key;
                                    const val = value;
                                    document.documentElement.style.setProperty(
                                        element,
                                        val
                                    );
                                }
                            );
                        }
                    }
                });
            this.subcriptionArr.push(journalid);
        }
    }

    getArticlesList(section: string) {
        this.articleData = [];
        const queryParams = {
            length: 3,
            start: 0,
            search_key: '',
            search_filters: section,
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            journal_id:this.journalid
        };

        const journalid = this.articleService
            .getArticles(queryParams, this.journalid)
            .subscribe((result) => {
                if (result.data.length !== 0) this.articleData = result.data;
            });
        this.subcriptionArr.push(journalid);
    }

    getArticleImageUrl(oneArticle) {
        let url = '';
        url =
            oneArticle.volume +
            '/' +
            oneArticle.issue +
            '/' +
            oneArticle.article_id +
            '/' +
            oneArticle.article_cover_image;
        return url;
    }
    expandedAuthors: { [key: string]: boolean } = {};

    getAuthorNames(authors): string {
        return authors.map((a) => a.first_name + ' ' + a.last_name).join(', ');
    }
}
